import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import NewExploration from "../newExploration/NewExploration";
import NewExplorationDialog from "../newExplorationDialog/NewExplorationDialog";
import IFrameDialog from "../IFrameDialog/IFrameDialog";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import { useErrorBoundary } from "react-error-boundary";
import { useStore } from "csi/state/hooks";
import { useLocale } from "designSystem/locale";
import ExplorationsList from "../explorationsList/ExplorationsList";
import Loader from "../loader/Loader";
import ExplorationPinnedImagesList from "../explorationPinnedImagesList/ExplorationPinnedImagesList";
import { DeleteDialog } from "designSystem/index";
import RenameExplorationDialog from "../renameExplorationDialog/RenameExplorationDialog";

const FashionInspirationPaneBody = observer(() => {
	const { showBoundary } = useErrorBoundary();
	const { rightPaneStore } = useStore();
	const loc = useLocale();
	const { selected } = rightPaneStore;
	const paneTitle = loc.resource(selected.id);
	const fashionInspirationStore = useManageFashionInspirationStore();
	const {
		showNewExplorationPane,
		showExplorationsListPane,
		showExplorationPinnedImagesPane,
		openIFrameDialog,
		openNewExplorationDialog,
		setOpenNewExplorationDialog,
		error,
		showLoader,
		fetchInitialData,
		openDeleteExplorationDialog,
		explorationName,
		handleDeleteExploration,
		setOpenDeleteExplorationDialog,
		openRenameExplorationDialog,
	} = fashionInspirationStore;

	if (error) {
		showBoundary(error);
	}

	useEffect(() => {
		fetchInitialData();
	}, []);

	return (
		<>
			{showLoader && <Loader label={paneTitle.toLocaleLowerCase()} />}
			{showNewExplorationPane && <NewExploration handleNewExplorationClick={setOpenNewExplorationDialog} />}
			{showExplorationsListPane && <ExplorationsList />}
			{showExplorationPinnedImagesPane && <ExplorationPinnedImagesList />}
			{openNewExplorationDialog && <NewExplorationDialog />}
			{openIFrameDialog && <IFrameDialog />}
			{openRenameExplorationDialog && <RenameExplorationDialog />}
			<DeleteDialog
				nodeName={explorationName}
				onCancel={() => setOpenDeleteExplorationDialog(false)}
				onClose={() => setOpenDeleteExplorationDialog(false)}
				onConfirm={handleDeleteExploration}
				open={openDeleteExplorationDialog}
				typeName={loc.resource("Exploration")}
			/>
		</>
	);
});

export default FashionInspirationPaneBody;
